<template>
	<div>
		<div class="" v-if="showChart && Object.keys(this.selectedAreaData).length > 0">
                
                <!-- 도시데이터 축약 팝업 시작 -->
                <div id="citydataPop" class="citydata_report_popup home" v-show="subMenu == 'short'">
                    <div class="home_top_area">
                        <h2>지금 
                            <span class="color-02">{{ this.selectedAreaData.key }}</span>
                            {{ ['강남 MICE 관광특구','청담동 명품거리','압구정로데오거리'].includes(this.selectedAreaData.key) ? '는' : '은' }}
                        </h2>
                        <div class="date">※ {{ setDate(this.selectedAreaData.LIVE_PPLTN_STTS) }} 기준 
                            <!-- <a href="" class="btn_replay">새로고침</a> -->
                        </div>
                    </div>
                    <div class="report_wrap ps-01 scroll">       
                        <div class="home_area">
                            <div class="home_left">
                                <!-- 홈_인구 -->
                                <div class="rpt_inner">
                                    <h3 class="top_tit2">
                                        <i class="top_ic01"></i>
                                        <a href="javascript:void(0);" @click.prevent="selectSubMenu('pop')">실시간 인구</a></h3>
                                    <div class="top_sts">
                                        <span>인구혼잡도</span>가
                                        <b :class="['color-0' + this.selectedAreaData.popKey]">{{ this.selectedAreaData.LIVE_PPLTN_STTS[0].AREA_CONGEST_LVL }}</b>
                                        <!-- <b class="color-02">보통</b>
                                        <b class="color-03">약간 붐빔</b>
                                        <b class="color-04">붐빔</b> -->
                                        입니다
                                    </div>
                                    
                                    <ul class="rpt_ul mt10" v-if="this.selectedAreaData.LIVE_PPLTN_STTS[0].AREA_CONGEST_MSG !== ''">
                                        <li>{{ this.selectedAreaData.LIVE_PPLTN_STTS[0].AREA_CONGEST_MSG }}</li>
                                    </ul>
                                    <h3 class="sub_tit mt10">실시간 인구 및 혼잡도 추이 전망 </h3>
    
                                    <div class="grp_wrap ps-01">
                                        <div class="grp_chart">
                                            <canvas id="chart-fcstPpltn-abb" :key="this.selectedAreaData.key + '_abbreciation'"></canvas>
                                        </div>
                                    </div>
                                </div>
    
                                <!-- 홈_환경 -->
                                <div class="rpt_inner" v-for="weather in this.selectedAreaData.WEATHER_STTS">
                                    <h3 class="top_tit2" v-if="!!weather.AIR_IDX">
                                        <i class="top_ic02"></i>
                                        <a href="javascript:void(0);" @click.prevent="selectSubMenu('weather')">날씨/환경 상황</a>
                                    </h3>
    
                                    <div class="top_sts" v-if="!!weather.AIR_IDX">
                                        <span class="">통합대기환경지수</span>는 
                                        <b :class="['color-0' + setWeatherIdx(weather.AIR_IDX)]">{{ weather.AIR_IDX }}({{ weather.AIR_IDX_MVL }})</b> 입니다 
                                    </div>
    
                                    <div class="rpt_info06 mt10" v-if="!!weather.AIR_IDX">
                                        <ul class="li3">
                                            <li>
                                                <b class="temp1 color-01">{{ weather.TEMP }}℃</b>  체감온도 <span class=" temp2">{{ weather.SENSIBLE_TEMP }}℃</span>
                                            </li>
                                            <li>
                                                자외선지수 <span :class="['color-0' + weather.UV_INDEX_LVL]"> {{ weather.UV_INDEX }}</span>
                                            </li>
                                            <li>
                                                강수량 <span class="color-02">{{ weather.PRECIPITATION }}</span>
                                            </li>
                                        </ul>
                                    </div>
    
                                    <div class="rpt_info07 mt10" v-if="!!weather.AIR_IDX">
                                        <ul class="li2">
                                            <li>
                                                미세먼지 <span :class="['color-0' + setWeatherIdx(weather.PM10_INDEX)]">{{ weather.PM10 }}㎍/㎥ ({{ weather.PM10_INDEX }})</span>
                                            </li>
                                            <li>
                                                초미세먼지 <span :class="['color-0' + setWeatherIdx(weather.PM25_INDEX)]">{{ weather.PM25 }}㎍/㎥ ({{ weather.PM25_INDEX }})</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
    
                            
                            <!-- 홈_교통 -->
                            <div class="rpt_inner mt-20">
                                <h3 class="top_tit2">
                                    <i class="top_ic03"></i>
                                    <a href="javascript:void(0);"  @click.prevent="selectSubMenu('road')">교통상황</a>
                                </h3>
                                
                                <div class="top_sts">
                                    <span class="">도로소통 단계</span>
                                    <b :class="['color-0' + setRoadStatus(this.selectedAreaData.AVG_ROAD_DATA.get('ROAD_TRAFFIC_IDX'))]">{{ this.selectedAreaData.AVG_ROAD_DATA.get('ROAD_TRAFFIC_IDX') }}</b>
                                </div>

                                <div class="rpt_home_traffic">
                                    <div class="tr_box">
                                        <h4 class="sub_tit3"><i class="ic_tr04"></i>사고돌발건수</h4>
                                        <div class="tr_data">
                                            <b><span class="color-01">{{ acdntCntrlStts.accident }}</span> 건</b>
                                        </div>
                                        <button class="btn_s_more" @click.prevent="selectSubMenu('road')">자세히</button>
                                    </div>
                                    <div class="tr_box">
                                        <h4 class="sub_tit3"><i class="ic_tr02"></i>전기차 충전기</h4>
                                        <div class="tr_data">
                                            <span class="color-02"><b>{{ chargerState(this.selectedAreaData.CHARGER_STTS, '사용가능') }}</b></span>
                                            <span>잔여 충전기</span>
                                            /
                                            <span class="color-03">{{ chargerState(this.selectedAreaData.CHARGER_STTS, '총') }}</span>
                                            <span>총 충전기 수</span>
                                        </div>
                                        <button class="btn_s_more" @click.prevent="selectSubMenu('pk')">자세히</button>
                                    </div>
                                    <div class="tr_box">
                                        <h4 class="sub_tit3"><i class="ic_tr03"></i>잔여주차공간</h4>
                                        <div class="tr_data">
                                            <span class="color-02"><b>{{ setTotalPk(this.selectedAreaData.PRK_STTS).available }}</b></span>
                                            <span> 잔여공간</span>
                                            /
                                            <span class="color-04">{{ setTotalPk(this.selectedAreaData.PRK_STTS).total }}</span>
                                            <span> 총 주차공간</span>
                                        </div>
                                        <button class="btn_s_more" @click.prevent="selectSubMenu('pk')">자세히</button>
                                    </div>
                                    
                                    <div class="tr_box" v-if="this.selectedAreaData.BUS_STN_STTS.length > 0">
                                        <h4 class="sub_tit3"><i class="ic_tr05"></i>버스</h4>
                                        <div class="tr_data">
                                            <a class="color-01"><b>{{ this.selectedAreaData.BUS_STN_STTS[0].BUS_DETAIL.length }}개 노선</b></a> 
                                        </div>
                                    </div>
                                    <div class="tr_box">
                                        <h4 class="sub_tit3"><i class="ic_tr06"></i>지하철</h4>
                                        <div class="tr_data">
                                            <a href="javascript:void(0);" v-for="sub in subwayUnduplication(this.selectedAreaData.SUB_STTS)">
                                                <i class="ico_subway">
                                                    <img :src="$_WC.assets + 'img/ico/subway_outline_0' + setSubwayImgNumber(sub) + '.png'">
                                                </i>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="tr_box">
                                        <h4 class="sub_tit3"><i class="ic_tr07"></i>따릉이</h4>
                                        <div class="tr_data">
                                            <span class="color-01"><b>{{ sbikeSum.parkingCnt }}</b></span>
                                            <span>잔여대수</span>
                                            /
                                            <span class="color-03">{{ sbikeSum.rackCnt }}</span>
                                            <span>총 거치대 개수</span>
                                        </div>       
                                        <button class="btn_s_more" @click.prevent="selectSubMenu('sub')">자세히</button>
                                        </div>
                                </div>
                            </div>

                            <!-- 홈_문화행사 -->
                            <div class="rpt_inner mt-20 ps-01">
                                <h3 class="top_tit2"> <i class="top_ic04"></i> 문화행사</h3>

                                <div class="top_sts">
                                    <span class="">오늘의 문화행사</span>
                                    <b class="color-02">{{ this.selectedAreaData.EVENT_STTS.length }}</b>건
                                </div>
                            </div>
                        
                            <div class="sub_txt">
                                실시간 환경에 따라 오차가 발생 할 수 있습니다.
                            </div>
                        </div>
                    </div>
                    <!--report_wrp//end -->
                    
                    <div class="popup_btn_area pos03 right"><a href="" class="popup_btn_close" @click.prevent="hideChart()">닫기</a></div>
                </div>
                <!-- 도시데이터 축약 팝업 종료 -->
                
                <!-- 도시데이터 인구 팝업 시작 -->
    			<div class="citydata_report_popup" v-show="subMenu == 'pop'">
                    <div class="home_top_area">
                        <p class="date">※ {{ setDate(this.selectedAreaData.LIVE_PPLTN_STTS) }} 기준</p>
                        <h2>지금 
                            <span class="color-02">{{ this.selectedAreaData.key }}</span>
                            {{ ['강남 MICE 관광특구','청담동 명품거리','압구정로데오거리'].includes(this.selectedAreaData.key) ? '는' : '은' }}
                        </h2>
                    </div>
                    <div class="report_wrap ps-01 scroll">
                        <div class="rpt_inner">
                            <p class="date_right">※ {{ setDate(this.selectedAreaData.LIVE_PPLTN_STTS) }} 기준</p>
                            <h2 class="top_sts">
                                인구혼잡도 
                                <b :class="['rpt_data color-0' + this.selectedAreaData.popKey ]">{{ this.selectedAreaData.LIVE_PPLTN_STTS[0].AREA_CONGEST_LVL }}</b>
                                <!-- <b class="rpt_data color-02">보통</b>
                                <b class="rpt_data color-03">약간 붐빔</b>
                                <b class="rpt_data color-04">붐빔</b> -->
                            </h2>
    
                            <div class="report_guage people">
                                <div class="gg_graphic">
                                    <img :src="$_WC.assets + 'img/ico/graphic_popul_0' + this.selectedAreaData.popKey +'.png'">
                                </div>
                                <!-- 이미지명 마지막 1~4까지 상태에 따라 변경 -->
                                <ul class="gg_text li4">
                                    <li :class="['gg_pop', this.selectedAreaData.popKey == '1' ? 'on' : 'off']">
                                        <span class="color-01">여유</span>
                                    </li>
                                    <li :class="['gg_pop', this.selectedAreaData.popKey == '2' ? 'on' : 'off']">
                                        <span class="color-02">보통</span>
                                    </li>
                                    <li :class="['gg_pop', this.selectedAreaData.popKey == '3' ? 'on' : 'off']">
                                        <span class="color-03">약간 붐빔</span>
                                    </li>
                                    <li :class="['gg_pop', this.selectedAreaData.popKey == '4' ? 'on' : 'off']">
                                        <span class="color-04">붐빔</span>
                                    </li>                        
                                </ul>
                                <!-- 해당되는 상태에 on// -->
                            </div>
                            
                            <ul class="rpt_ul mt-10">
                                <li>{{ this.selectedAreaData.LIVE_PPLTN_STTS[0].AREA_CONGEST_MSG }}</li>
                            </ul>
                            <!-- 아래의 데이터는 존재하지 않음. -->
                            <!-- <div class="rpt_info01">
                                <div class="ico_past"><img :src="$_WC.assetsCp + '/gn/images/ico_time.png'"></div>
                                <ul class="rpt_ul">
                                    <li>
                                        <div class="txt">1시간 전 대비 증감율</div>
                                        <div class="arr_down">2.1%</div>
                                    </li>
                                    <li>
                                        <div class="txt">3시간 전 대비 증감율</div>
                                        <div class="arr_bar">0.0%</div>
                                    </li>
                                    <li>
                                        <div class="txt">최근 28일 동시간 평균 대비 증감율</div>
                                        <div class="arr_up">54.1%</div>
                                    </li>
                                </ul>
                            </div> -->
                            
                            <div class="sub_txt mt-10">
                                ※ 혼잡도는 통신사의 실시간 인구 데이터를 분석하여 가공한 것으로, 실제 현장과는 차이가 있을 수 있음을 알려드립니다.
                            </div>
                        </div>
                        
                        
                        <div class="rpt_inner mt-20">
                            <h3 class="sub_tit">실시간 인구 및 혼잡도 추이 전망 <span class="text_rt"> <span class="pop_date_right">※ {{ setDate(this.selectedAreaData.LIVE_PPLTN_STTS) }} 기준</span></span></h3>
        
                            <div class="grp_wrap ps-01">
                                <!-- <div class="grp_title">{{ this.selectedAreaData.key }} 실시간 인구데이터 예측인구추이</div> --> 
                                <div class="grp_chart">
                                    <canvas id="chart-fcstPpltn" :key="this.selectedAreaData.key"></canvas>
                                </div>
                            </div>
                            <!-- grp_wrap//end -->
                        </div>
                        
                        <div class="rpt_inner mt20">
                            <h3 class="sub_tit b_line">실시간 인구 구성 비율 <span class="pop_date_right">※ {{ setDate(this.selectedAreaData.LIVE_PPLTN_STTS) }} 기준</span></h3>
                            <h4 class="sub_tit2 mt-10">성별 비율</h4>                    
                            
                            <Gripchart chartid="1843" 
                                :key="this.selectedAreaData.key + '-1843'"
                                :params="'param1=' + encodeURIComponent(this.selectedAreaData.key)" 
                                :more-class="'ps-02'"
                                :show-grp-title="false"
                                :show-grp-stand="false"
                                :show-grp-source="false"
                                :font-magnification="2"
                            ></Gripchart>
                            
                            <!-- grp_wrap//end -->
    
                            <ul class="rpt_ul mt-2" v-if="Object.keys(this.realtimeCityMap).length > 0 && !!this.selectedAreaData.key">
                                <li class="rpt_data">
                                <b class="color-05">남성</b>이 여성보다 
                                <b class="color-05">{{ setMfPerc(this.realtimeCityMap[this.selectedAreaData.key], 'val6', 'val7') }}%</b>
                                {{ setSentence(this.realtimeCityMap[this.selectedAreaData.key], 'val6', 'val7') }}</li>
                            </ul>
    
                            <h4 class="sub_tit2 mt10">연령대별 비율</h4>
                            <Gripchart chartid="1844" 
                                :key="this.selectedAreaData.key + '-1844'"
                                :params="'param1=' + encodeURIComponent(this.selectedAreaData.key)" 
                                :more-class="'ps-03'"
                                :show-grp-title="false"
                                :show-grp-stand="false"
                                :show-grp-source="false"
                                :font-magnification="2"
                            ></Gripchart>
                            <!-- grp_wrap//end -->
                            
                            <ul class="rpt_ul mt10">
                                <li class="rpt_data">전체 연령대 중 <b class="color-05">{{ setMostAge(this.realtimeCityMap[this.selectedAreaData.key]).valKd }}</b>가  
                                <b class="color-05">{{ setMostAge(this.realtimeCityMap[this.selectedAreaData.key]).value }}%</b>로 가장 많아요</li>
                            </ul>
    
                            <h4 class="sub_tit2 mt10">상주·비상주 비율</h4>
    
                            <Gripchart chartid="1845" 
                                :key="this.selectedAreaData.key + '-1845'"
                                :params="'param1=' + encodeURIComponent(this.selectedAreaData.key)" 
                                :more-class="'ps-04'"
                                :show-grp-title="false"
                                :show-grp-stand="false"
                                :show-grp-source="false"
                                :font-magnification="2"
                            ></Gripchart>
                            <!-- grp_wrap//end -->
                                
                            <ul class="rpt_ul mt10">
                                <li class="rpt_data"><b class="color-05">비상주</b> 인구가 상주 인구보다 
                                <b class="color-05">{{ setMfPerc(this.realtimeCityMap[this.selectedAreaData.key], 'val17', 'val16') }}%</b> 더 
                                {{ setSentence(this.realtimeCityMap[this.selectedAreaData.key], 'val17', 'val16') }}.</li>
                            </ul>
                            <div class="sub_txt mt-10">
                                ※ 상주 인구는 '전월 가장 오래 체류했던 장소'에 존재하고 있는 인구입니다. (전월 일 4시간 이상, 최소 10일 이상 연속 체류한 장소 기준)
                            </div>
                        </div>
                        
                        <div class="rpt_inner mt20">
                            <h3 class="sub_tit">문화행사 정보</h3>
    
                            <div class="tbl_wrp">
                                <div class="tbl_top">
                                    <table class="tbl01">
                                        <colgroup>
                                            <col style="width: 40%;">
                                            <col style="width: 20%;">
                                            <col style="width: 40%;">
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>행사명</th>
                                                <th>행사기간</th>
                                                <th>행사주소</th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
    
                                <div class="sc_box h200 scroll">
                                    <table class="tbl01">
                                        <colgroup>
                                            <col style="width: 40%;">
                                            <col style="width: 20%;">
                                            <col style="width: 40%;">
                                        </colgroup>
                                        <tbody v-if="this.selectedAreaData.EVENT_STTS.length > 0">
                                            <tr v-for="ev in this.selectedAreaData.EVENT_STTS">
                                                <td><a :href="setCultureUrl(ev)" style="cursor:pointer" target="_blank">{{ ev.EVENT_NM }}</a></td>
                                                <td class="center">{{ ev.EVENT_PERIOD }}</td>
                                                <td>{{ ev.EVENT_PLACE }}</td>
                                            </tr>
                                        </tbody>
                                        <tbody v-if="this.selectedAreaData.EVENT_STTS.length == 0">
                                            <tr>
                                                <td class="center" colspan="3">
                                                    {{ this.selectedAreaData.key }}의 문화행사 정보가 없습니다.
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            
                        </div>
                        
                        <div class="popup_btn_area pos03 right"><a href="" class="popup_btn_close" @click.prevent="hideChart()">닫기</a></div>
                    </div>
                </div>
                <!-- 도시데이터 인구 팝업 종료 -->
                
                <!-- 도시데이터 도로 팝업 시작 -->
                <div class="citydata_report_popup" v-show="subMenu == 'road'">
                    <div class="home_top_area">
                        <p class="date">※ {{ this.selectedAreaData.AVG_ROAD_DATA.get("ROAD_TRFFIC_TIME") }} 기준</p>
                        <h2>지금 
                            <span class="color-02">{{ this.selectedAreaData.key }}</span>
                            {{ ['강남 MICE 관광특구','청담동 명품거리','압구정로데오거리'].includes(this.selectedAreaData.key) ? '는' : '은' }}
                        </h2>
                    </div>
                    <div class="report_wrap ps-01 scroll">
                        <div class="rpt_inner">
                            <p class="date_right">※ {{ this.selectedAreaData.AVG_ROAD_DATA.get("ROAD_TRFFIC_TIME") }} 기준</p>
                            <h2 class="top_sts">
                                도로소통 단계 <b :class="['color-0' + setRoadStatus(this.selectedAreaData.AVG_ROAD_DATA.get('ROAD_TRAFFIC_IDX'))]">{{ this.selectedAreaData.AVG_ROAD_DATA.get('ROAD_TRAFFIC_IDX') }}</b>
                            </h2>
    
                            <div class="report_guage traffic">
                                <div class="gg_graphic">
                                    <img :src="$_WC.assets + 'img/ico/graphic_traffic_0' + setRoadImgIdx(this.selectedAreaData.AVG_ROAD_DATA.get('ROAD_TRAFFIC_IDX')) + '.png'">
                                </div>
                                <ul class="gg_text li3">
                                    <li :class="['gg_pop', setRoadImgIdx(this.selectedAreaData.AVG_ROAD_DATA.get('ROAD_TRAFFIC_IDX')) == '1' ? 'on' : 'off']">
                                        <span class="color-01">원활</span>
                                    </li>
                                    <li :class="['gg_pop', setRoadImgIdx(this.selectedAreaData.AVG_ROAD_DATA.get('ROAD_TRAFFIC_IDX')) == '2' ? 'on' : 'off']">
                                        <span class="color-02">서행</span>
                                    </li>
                                    <li :class="['gg_pop', setRoadImgIdx(this.selectedAreaData.AVG_ROAD_DATA.get('ROAD_TRAFFIC_IDX')) == '3' ? 'on' : 'off']">
                                        <span class="color-03">정체</span>
                                    </li>
                                </ul>
                                <!-- 해당되는 상태에 on// -->
                            </div>
    
                            <div class="rpt_info02 mt-10">
                                평균 주행 속도 
                                <b class="">
                                    <span :class="['color-0'+setRoadImgIdx(this.selectedAreaData.AVG_ROAD_DATA.get('ROAD_TRAFFIC_IDX'))]">{{ this.selectedAreaData.AVG_ROAD_DATA.get('ROAD_TRAFFIC_SPD') }}km/h</span>
                                </b>
                            </div>
                            <ul class="rpt_ul mt-10">
                                <li class="">{{ this.selectedAreaData.AVG_ROAD_DATA.get('ROAD_MSG') }}</li>
                            </ul>
                        </div>
                        
                        <div class="rpt_inner mt-20">
                            <h3 class="sub_tit b_line">사고/통제 현황 <span class="pop_date_right">※ {{ this.selectedAreaData.AVG_ROAD_DATA.get("ROAD_TRFFIC_TIME") }} 기준</span></h3>
    
                            <div class="rpt_info03">
                                <ul class="li4">
                                    <li>
                                        <i class="ic-01">car_crash</i>
                                        <div class="txt">사고/고장</div>
                                        <div class=""><b class="color-01">{{ acdntCntrlStts.accident }}건</b></div>
                                    </li>
                                    <li>
                                        <i class="ic-02">groups</i>
                                        <div class="txt">공사/집회</div>
                                        <div class=""><b class="color-02">{{ acdntCntrlStts.construction }}건</b></div>
                                    </li>
                                    <li>
                                        <i class="ic-03">local_fire_department</i>
                                        <div class="txt">기상/화재</div>
                                        <div class=""><b class="color-03">{{ acdntCntrlStts.fire }}건</b></div>
                                    </li>
                                    <li>
                                        <i class="ic-04">info</i>
                                        <div class="txt">기타</div>
                                        <div class=""><b class="color-04">{{ acdntCntrlStts.etc }}건</b></div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        
                        <div class="rpt_inner mt-20">
                            <h3 class="sub_tit">도로 소통 현황 <span class="pop_date_right">{{ this.selectedAreaData.AVG_ROAD_DATA.get("ROAD_TRFFIC_TIME") }} 기준</span></h3>
                            <!-- <h4 class="sub_tit2 mt10">도로 소통 현황</h4> -->
                            <div class="tbl_wrp">
                                <div class="tbl_top">
                                    <table class="tbl01">
                                        <colgroup>
                                            <col style="width: 50%;">
                                            <col style="width: 25%;">
                                            <col style="width: 25%;">
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>구간명</th>
                                                <th>평균속도</th>
                                                <th>상태</th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div class="sc_box h300 scroll">
                                    <table class="tbl01">
                                        <colgroup>
                                            <col style="width: 50%;">
                                            <col style="width: 25%;">
                                            <col style="width: 25%;">
                                        </colgroup>
                                        <tbody>
                                            <tr v-for="road in this.selectedAreaData.ROAD_TRAFFIC_STTS">
                                                <td>
                                                    <b>{{ road.ROAD_NM }}</b>
                                                    <p>{{ road.START_ND_NM }}~{{ road.END_ND_NM }}</p>
                                                </td>
                                                <td class="center"><span :style="'color:' + setRoadStsClr(road.IDX)">{{ road.SPD }}km/h</span></td>
                                                <td class="center"><span :style="'color:' + setRoadStsClr(road.IDX)">{{ road.IDX }}</span></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--report_wrp//end -->
                    
                    <div class="popup_btn_area pos03 right"><a href="" class="popup_btn_close" @click.prevent="hideChart()">닫기</a></div>
                </div>
                <!-- 도시데이터 도로 팝업 종료 -->
                
                <!-- 도시데이터 대중교통 팝업 시작 -->
                <div class="citydata_report_popup" v-show="subMenu == 'sub'">
                    <div class="home_top_area">
                        <div class="date">※ {{ this.selectedAreaData.AVG_ROAD_DATA.get("ROAD_TRFFIC_TIME") }} 기준</div>
                        <h2>지금 
                            <span class="color-02">{{ this.selectedAreaData.key }}</span>
                            {{ ['강남 MICE 관광특구','청담동 명품거리','압구정로데오거리'].includes(this.selectedAreaData.key) ? '는' : '은' }}
                        </h2>
                    </div>
                    <div class="report_wrap ps-01 scroll">
                        <!-- 버스 -->
                        <div class="rpt_inner mt-10" v-if="this.selectedAreaData.BUS_STN_STTS.length > 0">
                            <h3 class="sub_tit b_line">버스 도착정보 <span class="pop_date_right">※ {{ this.selectedAreaData.AVG_ROAD_DATA.get("ROAD_TRFFIC_TIME") }} 기준</span></h3>
    
                            <div class="tbl_wrp">
                                <div class="tbl_top">
                                    <table class="tbl01">
                                        <colgroup>
                                            <col style="width: 35%;">
                                            <col style="width: 20%;">
                                            <col style="width: 30%;">
                                            <col style="width: 15%;">
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>정류장 이름</th>
                                                <th>노선</th>
                                                <th>도착 예정</th>
                                                <th>혼잡도</th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div class="sc_box h300 scroll">
                                    <table class="tbl01">
                                        <colgroup>
                                            <col style="width: 35%;">
                                            <col style="width: 20%;">
                                            <col style="width: 30%;">
                                            <col style="width: 15%;">
                                        </colgroup>
                                        <tbody>
                                            <template v-for="busStn in this.selectedAreaData.BUS_STN_STTS">
                                                <tr v-for="bus in busStn.BUS_DETAIL">
                                                    <td>{{ busStn.BUS_STN_NM }}</td>
                                                    <td class="center">{{ bus.RTE_NM }}</td>
                                                    <td class="center">
                                                        <p class="color-04">{{ bus.RTE_ARRV_TM_1 }}</p>
                                                    </td>
                                                    <td class="center"><span>{{ bus.RTE_CONGEST_1 }}</span></td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <!-- 지하철 -->
                        <div class="rpt_inner mt-10">
                            <h3 class="sub_tit b_line">지하철 도착정보 <span class="pop_date_right">※ {{ this.selectedAreaData.AVG_ROAD_DATA.get("ROAD_TRFFIC_TIME") }} 기준</span></h3>
    
                            <div class="tbl_wrp">
                                <div class="tbl_top">
                                    <table class="tbl01">
                                        <colgroup>
                                            <col style="width: 20%;">
                                            <col style="width: 10%;">
                                            <col style="width: 40%;">
                                            <col style="width: 30%;">
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>역명</th>
                                                <th>호선</th>
                                                <th>라인</th>
                                                <th>도착예정</th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
    
                                <div class="sc_box h300 scroll">
                                    <table class="tbl01">
                                        <colgroup>
                                            <col style="width: 20%;">
                                            <col style="width: 10%;">
                                            <col style="width: 40%;">
                                            <col style="width: 30%;">
                                        </colgroup>
                                        <tbody>
                                            <template v-for="subStn in this.selectedAreaData.SUB_STTS">
                                                <tr v-for="subway in subStn.SUB_DETAIL">
                                                    <td class="center">{{ subStn.SUB_STN_NM }}</td>
                                                    <td class="center">
                                                        <i class="ico_subway"><img :src="$_WC.assets + 'img/ico/subway_outline_0' + setSubwayImgNumber(subStn.SUB_STN_LINE) + '.png'"></i>
                                                    </td>
                                                    <td>{{ subway.SUB_ROUTE_NM }}</td>
                                                    <td class="center">{{ subway.SUB_ARMG1 }}</td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <!-- 따릉이 -->
                        <div class="rpt_inner mt-10" v-if="this.selectedAreaData.SBIKE_STTS.length > 0">
                            <h3 class="sub_tit b_line">따릉이 거치현황 <span class="pop_date_right">※ {{ this.selectedAreaData.AVG_ROAD_DATA.get("ROAD_TRFFIC_TIME") }} 기준</span></h3>
    
                            <div class="rpt_info04">
                                <ul class="li2">
                                    <li>
                                        <p>잔여 대수</p>
                                        <b class="color-01"><span>{{ sbikeSum.parkingCnt }}</span></b>/<span>{{ sbikeSum.rackCnt }}</span>
                                    </li>
                                    <li>
                                        <p>평균 거치율</p>
                                        <b class="color-01"><span>{{ sbikeSum.rate }}%</span></b>
                                    </li>
                                </ul>
                            </div>
    
                            <div class="tbl_wrp">
                                <div class="tbl_top">
                                    <table class="tbl01">
                                        <colgroup>
                                            <col style="width: 60%;">
                                            <col style="width: 20%;">
                                            <col style="width: 20%;">
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th style="width:200px">대여소</th>
                                                <th>잔여 현황</th>
                                                <th>거치율</th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
    
                                <div class="sc_box h200 scroll">
                                    <table class="tbl01">
                                        <colgroup>
                                            <col style="width: 60%;">
                                            <col style="width: 20%;">
                                            <col style="width: 20%;">
                                        </colgroup>
                                        <tbody>
                                            <tr v-for="sbike in this.selectedAreaData.SBIKE_STTS">
                                                <td>{{ sbike.SBIKE_SPOT_NM }}({{ sbike.SBIKE_SPOT_ID }})</td>
                                                <td class="center"><span class="color-01">{{ sbike.SBIKE_PARKING_CNT }}</span>/{{ sbike.SBIKE_RACK_CNT }}</td>
                                                <td class="center"><span class="color-04">{{ sbike.SBIKE_SHARED }}%</span></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--report_wrp//end -->
                    
                    <div class="popup_btn_area pos03 right"><a href="" class="popup_btn_close" @click.prevent="hideChart()">닫기</a></div>
                </div>
                <!-- 도시데이터 대중교통 팝업 종료 -->

                <!-- 도시데이터 날씨/환경 팝업 시작 -->
                <div class="citydata_report_popup" v-show="subMenu == 'weather'" v-for="weather in this.selectedAreaData.WEATHER_STTS">
                    <div class="home_top_area">
                        <h2>지금 
                            <span class="color-02">{{ weather.key }}</span>
                            {{ ['강남 MICE 관광특구','청담동 명품거리','압구정로데오거리'].includes(weather.key) ? '는' : '은' }}
                        </h2>
                    </div>
                    <div class="report_wrap ps-01 scroll">
                        <!-- 실시간 날씨 현황 -->
                        <div class="rpt_inner mt-10">
                            <h3 class="sub_tit b_line">실시간 날씨 현황 <span class="pop_date_right">※ {{ weather.WEATHER_TIME }} 기준</span></h3>
                            
                            <!-- 기온 -->
                            <div class=" rpt_info06">
                                <ul class="li2">
                                    <li>
                                        <div class="d01">
                                            <i class="ic_w01"><img :src="$_WC.assets + 'img/ico/icon_temperature.png'"></i>
                                            <b class=" temp1 color-01">{{ weather.TEMP }}℃</b>
                                        </div>
                                        <div class="d02">
                                            체감온도 
                                            <span class=" temp2">{{ weather.SENSIBLE_TEMP }}℃</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="d03">
                                            <i class="ic_w02"><img :src="$_WC.assets + 'img/ico/icon_moisture.png'"></i>
                                            습도 <b class="">{{ weather.HUMIDITY }}%</b>
                                        </div>
                                        <div class="d04">
                                            <i class="ic_w02"><img :src="$_WC.assets + 'img/ico/icon_wind.png'"></i>
                                            바람 <b class="">{{ weather.WIND_SPD }}m/s</b>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <!-- 습도 바람 -->
    
                            <!-- 최저최고 일출일몰 -->
                            <div class=" rpt_info07_1">
                                <ul class="li4">
                                    <li>
                                        최저기온 <br clear="m-visible"> <b class="color-wh">{{ weather.MIN_TEMP }}℃</b>
                                    </li>
                                    <li>
                                        최고기온 <br clear="m-visible"> <b class="color-wh">{{ weather.MAX_TEMP }}℃</b> 
                                    </li>
                                    <li>
                                        일출 <br clear="m-visible"> <b class="color-wh">{{ weather.SUNRISE }}</b>
                                    </li>
                                    <li>
                                        일몰 <br clear="m-visible"> <b class="color-wh">{{ weather.SUNSET }}</b>
                                    </li>
                                </ul>
                            </div>
    
                            <!-- 강수량 / 자외선 -->
                            <div class="rpt_info08 mt-10">
                                <ul class="li2">
                                    <li>
                                        <i class="ic_w01"><img :src="$_WC.assets + 'img/ico/ico_weather_rain.png'" class="ico_weather_rain"></i>
                                        <div class="cnt">
                                            강수량<br>
                                            <b class="color-05">{{ weather.PRECIPITATION }}</b>
                                        </div>
                                    </li>
                                    <li>
                                        <span class="txt">{{ weather.PCP_MSG }}({{ weather.PRECPT_TYPE }})</span>
                                    </li>
                                </ul>
                            </div>
    
                            <div class=" rpt_info08 mt-10">
                                <ul class="li2">
                                    <li>
                                        <i class="ic_w02"><img :src="$_WC.assets + 'img/ico/ico_weather_uv.png'" class="ico_weather_uv"></i>
                                        <div class="cnt">
                                            자외선지수<br>
                                            <b class="color-bk "><span :class="['color-0' + weather.UV_INDEX_LVL]"> {{ weather.UV_INDEX }}</span></b>
                                        </div>
                                    </li>
                                    <li>
                                        <span class="txt">{{ weather.UV_MSG }}</span>
                                    </li>
                                </ul>
                            </div>
    
                            <!-- 예보 테이블 -->
                            <h4 class="sub_tit2 mt-10">24시간 날씨 예보 </h4>
                            <div class="tbl_wrp scroll_x">
                                <table class="tbl01 w_00">
                                    <colgroup>
                                        <col style="width:100px;">
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <template v-for="(fcst, idx) in weather.FCST24HOURS">
                                                <th v-if="idx == 0"><span class="w20">시간</span></th>
                                                <td>{{ setWeatherHour(fcst.FCST_DT) }}</td>
                                            </template>
                                        </tr>
                                        <tr>
                                            <template v-for="(fcst, idx) in weather.FCST24HOURS">
                                                <th v-if="idx == 0"><span class="w20">날씨</span></th>
                                                <td>
                                                    <span class="ico_weahter">
                                                        <img :src="$_WC.assets + 'img/ico/ico_w_' + setWeatherIc(fcst, weather.SUNRISE, weather.SUNSET) + '.png'">
                                                    </span>
                                                </td>
                                            </template>
                                        </tr>
                                        <tr>
                                            <template v-for="(fcst, idx) in weather.FCST24HOURS">
                                                <th v-if="idx == 0"><span class="w20">기온</span></th>
                                                <td>{{ fcst.TEMP }}℃</td>
                                            </template>
                                        </tr>
                                        <tr>
                                            <template v-for="(fcst, idx) in weather.FCST24HOURS">
                                                <th v-if="idx == 0"><span class="w20">강수량<br>(mm)</span></th>
                                                <td>{{ fcst.PRECIPITATION }}</td>
                                            </template>
                                        </tr>
                                        <tr>
                                            <template v-for="(fcst, idx) in weather.FCST24HOURS">
                                                <th v-if="idx == 0"><span class="w20">강수<br> 확률</span></th>
                                                <td>{{ fcst.RAIN_CHANCE }}%</td>
                                            </template>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
    
                        <!-- 대기오염현황 -->
                        <div class="rpt_inner mt-20">
                            <h3 class="sub_tit">대기오염 현황 <span class="pop_date_right">※ {{ weather.WEATHER_TIME }} 기준</span></h3>
    
                            <h2 class="top_sts mt-10">통합대기환경지수 <b class=""><span :class="['color-0' + setWeatherIdx(weather.AIR_IDX)]">{{ weather.AIR_IDX }}({{ weather.AIR_IDX_MVL }})</span></b></h2>
    
                            <ul class="rpt_ul mt10">
                                <li>{{ weather.AIR_MSG }}</li>
                            </ul>
    
                            <div class="rpt_info04">
                                <ul class="li2">
                                    <li>
                                        <span>미세먼지 </span> <br clear="m-visible">
                                        <b :class="['color-0' + setWeatherIdx(weather.PM10_INDEX)]">{{ weather.PM10 }}㎍/㎥ ({{ weather.PM10_INDEX }})</b>
                                    </li>
                                    <li>
                                        <span>초미세먼지 </span> <br clear="m-visible">
                                        <b :class="['color-0' + setWeatherIdx(weather.PM25_INDEX)]">{{ weather.PM25 }}㎍/㎥ ({{ weather.PM25_INDEX }})</b>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <!--report_wrp//end -->
                    
                    <div class="popup_btn_area pos03 right"><a href="" class="popup_btn_close" @click.prevent="hideChart()">닫기</a></div>
                </div>
                <!-- 도시데이터 날씨/환경 팝업 종료 -->
                
                <!-- 도시데이터 주차장/전기차 팝업 시작 -->
                <div class="citydata_report_popup" v-show="subMenu == 'pk'">
                    <div class="home_top_area">
                        <div class="date">※ {{ this.selectedAreaData.AVG_ROAD_DATA.get("ROAD_TRFFIC_TIME") }} 기준</div>
                        <h2>지금 
                            <span class="color-02">{{ this.selectedAreaData.key }}</span>
                            {{ ['강남 MICE 관광특구','청담동 명품거리','압구정로데오거리'].includes(this.selectedAreaData.key) ? '는' : '은' }}
                        </h2>
                    </div>
                    <div class="report_wrap ps-01 scroll">
    
                        <div class="rpt_inner mt-10" v-if="this.selectedAreaData.PRK_STTS.length > 0">
                            <h3 class="sub_tit b_line">주차장 현황 <span class="pop_date_right">※ {{ this.selectedAreaData.AVG_ROAD_DATA.get("ROAD_TRFFIC_TIME") }} 기준</span></h3>
    
                            <div class="rpt_info04">
                                <ul class="li2">
                                    <li>
                                        <p>잔여 주차공간</p>
                                        <b class="color-01"><span class="">{{ setTotalPk(this.selectedAreaData.PRK_STTS).available }}</span></b>/<span class="">{{ setTotalPk(this.selectedAreaData.PRK_STTS).total }}</span> 
                                    </li>
                                    <li>
                                        <p>주차장 잔여율</p>
                                        <b class="color-01"><span class="">{{ setTotalPk(this.selectedAreaData.PRK_STTS).perc }}%</span></b>
                                    </li>
                                </ul>
                            </div>
                            <div class="tbl_wrp">
                                <div class="tbl_top">
                                    <table class="tbl01">
                                        <colgroup>
                                            <col style="width: 33.33%">
                                            <col style="width: 33.33%">
                                            <col style="width: 33.33%">
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>주차장명</th>
                                                <th>잔여현황</th>
                                                <th>위치</th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div class="sc_box h200 scroll">
                                    <table class="tbl01">
                                        <colgroup>
                                            <col style="width: 33.33%">
                                            <col style="width: 33.33%">
                                            <col style="width: 33.33%">
                                        </colgroup>
                                        <tbody>
                                            <tr v-for="pk in this.selectedAreaData.PRK_STTS">
                                                <td>{{ pk.PRK_NM }}</td>
                                                <td class="center" v-if="pk.CUR_PRK_YN == 'Y'">
                                                    <span class="color-01">{{ Number(pk.CPCTY) - Number(pk.CUR_PRK_CNT) }}</span>/{{ pk.CPCTY }}
                                                </td>
                                                <td class="center" v-else>-</td>
                                                <td>{{ pk.ADDRESS }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="sub_txt mt-10">
                                ※ 주차 공간 대수는 “공영주차장” 중에서 실시간 조회가 가능한 주차장 기준으로만 제공됩니다.
                            </div>
                        </div>
                        <div class="rpt_inner mt-20" v-if="this.selectedAreaData.PRK_STTS.length == 0">
                            <h3 class="sub_tit b_line">주차장 정보</h3>
    
                            <div class="tbl_wrp">
                                <div class="sc_box scroll">
                                    <table class="tbl01">
                                        <colgroup>
                                            <col style="width: 40%;">
                                            <col style="width: 20%;">
                                            <col style="width: 40%;">
                                        </colgroup>
                                        <tbody>
                                            <tr>
                                                <td class="center" colspan="3">
                                                    {{ this.selectedAreaData.key }}의 주차장 정보가 없습니다.
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            
                        </div>
    
                        <div class="rpt_inner mt-20" v-if="this.selectedAreaData.CHARGER_STTS.length > 0">
                            <h3 class="sub_tit b_line">전기차 충전기 현황 <span class="pop_date_right">※ {{ this.selectedAreaData.AVG_ROAD_DATA.get("ROAD_TRFFIC_TIME") }} 기준</span></h3>
                            <div class="rpt_info04">
                                <ul class="li2">
                                    <li>
                                        <p>잔여 충전기 수</p>
                                        <b class="color-02"><span>{{ chargerSum.avCnt }}</span></b>/<span>{{ chargerSum.totalCnt }}</span>
                                    </li>
                                    <li>
                                        <p>충전기 잔여율</p>
                                        <b class="color-01"><span>{{ chargerRate(chargerSum) }}%</span></b>
                                    </li>
                                </ul>
                            </div>
                            <div class="tbl_wrp">
                                <div class="tbl_top">
                                    <table class="tbl01">
                                        <colgroup>
                                            <col style="width: 30%;">
                                            <col style="width: 15%;">
                                            <col style="width: 15%;">
                                            <col style="width: 20%;">
                                            <col style="width: 20%;">
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>충전기 ID</th>
                                                <th>충전기 타입</th>
                                                <th>충전방식</th>
                                                <th>충전기<br />충전용량</th>
                                                <th>충전기 상태</th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div class="sc_box h300 scroll">
                                    <table class="tbl01">
                                        <colgroup>
                                            <col style="width: 30%;">
                                            <col style="width: 15%;">
                                            <col style="width: 15%;">
                                            <col style="width: 20%;">
                                            <col style="width: 20%;">
                                        </colgroup>
                                        <tbody>
                                            <template v-for="charger in this.selectedAreaData.CHARGER_STTS">
                                                <tr v-for="cd in charger.CHARGER_DETAILS">
                                                    <td>{{ charger.STAT_NM }}-{{ cd.CHARGER_ID }}</td>
                                                    <td>{{ cd.CHARGER_TYPE }}</td>
                                                    <td>{{ cd.METHOD }}</td>
                                                    <td>{{ cd.OUTPUT }}</td>
                                                    <td>{{ cd.CHARGER_STAT }}</td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="sub_txt mt-10">
                                ※ 전기차 충전기 개수는 실시간 조회가 가능한 전기차 충전소 기준으로만 제공됩니다.
                            </div>
                        </div>
    
                    </div>
                    <!--report_wrp//end -->
                    
                    <div class="popup_btn_area pos03 right"><a href="" class="popup_btn_close" @click.prevent="hideChart()">닫기</a></div>
                </div>
                <!-- 도시데이터 주차장/전기차 팝업 종료 -->
		</div>
	</div>	
</template>
<script>
import Gripchart from '@/libs/grip.chart.v3.vue';
import naverMapShareMixins from '@/stores/naver.map.share.mixin';
import { mapGetters } from "vuex";
import { $_TYPE, $_WC } from '@/confs/common.const.js';
import Chartjs from 'chart.js';

export default {
    components: {
        Gripchart,
    },
	data: function(){
		return {
			selectedAreaData: {},
			showChart: false,
			cols: {
				'FCST_TIME': '일시',
				'FCST_CONGEST_LVL': 'data',
				'FCST_PPLTN_MIN': 'min',
				'FCST_PPLTN_MAX': 'max',
			},
			chartList: [1843, 1844, 1845],
			chartIdx: 0,
		}
	},
    watch: {
    	fcstPpltnList: {
            immediate: false,
            handler: function(newVal, oldVal) {
            	// this.showChart = false;
            	if(typeof newVal !== 'undefined'){
            	    if(['pop', 'short'].includes(this.subMenu)) {
            	        this.setPeopleData();            		            	        
            	    }
            	}
            }
        },
        realtimeCitySelectedList: {
            immediate: false,
            handler: function(newVal, oldVal) {
                // this.showChart = false;
                if(typeof newVal !== 'undefined') {
                    if(this.selectedAreaData.estimatePop == 'N' && ['pop', 'short'].includes(this.subMenu) ) {
                        this.setPopData();
                    }
                }
            }
        },
        showChart: {
            immediate: false,
            handler: function(newVal, oldVal) {
                // this.showChart = false;
                if(typeof newVal !== 'undefined') {
                    this.$eventBus.$emit('SeoulmapMapCtrl::realcity-map-button-style', newVal);
                    if(newVal == true) {
                        if(this.selectedAreaData.estimatePop == 'N') {
                            this.setPopData();
                        } else {
                            this.setPeopleData();
                        }                        
                    }
                }
            }
        },
        // selectedAreaData: {
        //     immediate: false,
        //     handler(newVal, oldVal) {
        //         console.log('newVal', newVal);        
        //     }
        // },
    },
	created(){
		this.$eventBus.$on("SeoulmapMapCtrl::loaded-seoulmap-data", function(selectedAreaData){
            this.selectedAreaData = selectedAreaData;
            // console.log('selectedAreaData', selectedAreaData);
            this.$store.dispatch("FETCH_REALTIME_CITY_SELECTED_LIST", 'where=val1::' + encodeURIComponent(selectedAreaData.key) + '&orderBy=basdtVal::desc&isUnescape=true&searchLimit=12');
        }.bind(this));

        this.$eventBus.$on("Close::Seoulmap:Detail::Win", (showPop) => {
            this.showChart = showPop;
        });
	},
	mounted: function() {
	    this.$eventBus.$on("SeoulmapMapCtrl::show-seoulmap-pop", function() {
	        if(typeof this.selectedAreaData !== 'undefined') {
    	        if(Object.keys(this.selectedAreaData).length > 0) {
        	        this.showChart = true;	            
    	        }	            
	        }
	    }.bind(this));
	    this.$eventBus.$on("SeoulmapMapCtrl::close-population-pop", function() {
	        this.showChart = false;
	    }.bind(this));
	},
    computed: {
        ...mapGetters({
            selectedSubMenus: 'getSelectedSubMenus',
            realtimeCitySelectedList: 'getRealtimeCitySelectedList',
            cultureEvent: 'getCultureEvent',
        }),
    	fcstPpltnList: function(){
    		if(typeof this.selectedAreaData.FCST_PPLTN !== 'undefined' && this.selectedAreaData.FCST_PPLTN.length > 0){
    			return this.selectedAreaData.FCST_PPLTN;
    		}
    	},
    	subMenu: function() {
    	    if(this.selectedSubMenus.length > 0) {
    	        return this.selectedSubMenus[0];
    	    }
    	},
    	chargerSum: function() {
    	    if(typeof this.selectedAreaData.CHARGER_STTS !== 'undefined' && this.selectedAreaData.CHARGER_STTS.length > 0){
    	        let map = {
    	                totalCnt: 0,
    	                avCnt: 0,
    	        }
    	        let chargerStts = this.selectedAreaData.CHARGER_STTS;
    	        chargerStts.forEach(function(d) {
    	            d.CHARGER_DETAILS.forEach(function(data) {
    	                map.totalCnt++;
    	                if(data.CHARGER_STAT == '사용가능') {
    	                    map.avCnt++;
    	                }
    	            }.bind(this));
    	        }.bind(this));
    	        return map;
    	    }
    	},
    	sbikeSum: function() {
            let map = {
                    rackCnt: 0,
                    parkingCnt: 0,
                    rate: 0,
            }
    	    if(typeof this.selectedAreaData.SBIKE_STTS !== 'undefined' && this.selectedAreaData.SBIKE_STTS.length > 0){
                let sbikeStts = this.selectedAreaData.SBIKE_STTS;
                sbikeStts.forEach(function(d) {
                    map.rackCnt = map.rackCnt + Number(d.SBIKE_RACK_CNT);
                    map.parkingCnt = map.parkingCnt + Number(d.SBIKE_PARKING_CNT);
                }.bind(this));
                
                
                let result = (map.parkingCnt / map.rackCnt) * 100;
                result = result.toFixed(1);
                map.rate = result;
                
            }
            return map;
    	},
    	acdntCntrlStts: function() {
    	    let map = {
    	            accident: 0,   // 사고/고장
    	            construction: 0,   // 공사/집회
    	            fire: 0,   // 기상/화재
    	            etc: 0     // 기타
    	    }
    	    if(typeof this.selectedAreaData.ACDNT_CNTRL_STTS !== 'undefined' && this.selectedAreaData.ACDNT_CNTRL_STTS.length > 0){
    	        let acdnt = this.selectedAreaData.ACDNT_CNTRL_STTS;
    	        acdnt.forEach(function(d) {
    	            if(d.ACDNT_TYPE == '사고' || d.ACDNT_TYPE == '고장') {
    	                map.accident++;  
    	            }
    	            if(d.ACDNT_TYPE == '공사' || d.ACDNT_TYPE == '집회') {
                        map.construction++;  
                    }
    	            if(d.ACDNT_TYPE == '기상' || d.ACDNT_TYPE == '화재') {
                        map.fire++;  
                    }
    	            if(d.ACDNT_TYPE == '기타') {
                        map.etc++;  
                    }
    	        }.bind(this));
    	    }
    	    return map;
    	},
    	realtimeCityMap: function() {
    	    return this.$store.getters.getRealtimeCityCalMap;
    	},
        
    },
    methods: {
        // 예측 인구 차트
    	setPeopleData(){
    		let labels = [];
    		let datas = [];
    		let colors = [];
    		this.showChart = true;
    		this.$nextTick(function() {
        		this.fcstPpltnList.forEach(function(d){
        			let date = new Date(d.FCST_TIME);
        			let dateStr = date.getDate() + '일 ' + date.getHours() + '시';
        			labels.push( dateStr );
        			datas.push( (Number(d.FCST_PPLTN_MIN) + Number(d.FCST_PPLTN_MAX)) /2 );
        			switch(d.FCST_CONGEST_LVL){
            			case '여유' : colors.push('#00D369'); break;
                        case '보통' : colors.push('#FFB100'); break;
                        case '약간 붐빔' : colors.push('#FF8040'); break;
                        case '붐빔' : colors.push('#DD1F3D'); break;
        				default: colors.push('rgba(54, 162, 235, 0.8)'); break;
        			}
        		});
        		
        	    let canvas = document.getElementById("chart-fcstPpltn");
                let ctx = canvas.getContext('2d');
                new Chart(ctx, this.setChartConf(labels, datas, colors));    		        
        		
        		// 축약페이지 차트
        		let canvasAbb = document.getElementById('chart-fcstPpltn-abb');
        		let ctx2 = canvasAbb.getContext('2d');
        		new Chart(ctx2, this.setChartConf(labels, datas, colors));
    		}.bind(this));
    	},
    	// 예측 인구값 제공 x일 때, 2015자료로 차트
    	setPopData() {
    	    let labels = [];
    	    let datas = [];
    	    let colors = [];
    	    this.showChart = true;
    	    this.$nextTick(function() {
    	        if(!!this.realtimeCitySelectedList) {
        	        let list = this.realtimeCitySelectedList.slice(-12, this.realtimeCitySelectedList.length);
                    // console.log('list', list);
        	        list.forEach(function(d) {
        	            let date = d.basdtVal.substring(6, 8) + '일' + d.basdtVal.substring(8,10) + '시';
        	            labels.push(date);
        	            let val = ( Number(d.val4) + Number(d.val5) ) / 2;
        	            datas.push(val);
        	            let color = 'rgba(54, 162, 235, 0.8)';
        	            switch(d.val2) {
        	               case '여유' : color = '#00D369'; break;
        	               case '보통' : color = '#FFB100'; break;
        	               case '약간 붐빔' : color = '#FF8040'; break;
        	               case '붐빔' : color = '#DD1F3D'; break;
        	            }
        	            colors.push(color);
        	        });
        	        let canvas = document.getElementById("chart-fcstPpltn");
                    let ctx = canvas.getContext('2d');
                    new Chart(ctx, this.setChartConf(labels, datas, colors));
        	        
        	        // 축약페이지 차트
        	        let canvasAbb = document.getElementById('chart-fcstPpltn-abb');
                    let ctx2 = canvasAbb.getContext('2d');
                    new Chart(ctx2, this.setChartConf(labels, datas, colors));
    	        }
    	    }.bind(this));
    	},
    	setChartConf(labels, datas, colors){
    		/*
            conf.options.title.display = false;
            conf.options.legend = {};
            conf.options.legend.display = false;
            conf.options.maintainAspectRatio = false;
    		 */
    		return {
    		    type: 'bar',
    		    data: {
    		        labels: labels,
    		        datasets: [{
    		            label: '',
    		            data: datas,
    		            backgroundColor: colors,
    		            borderColor: colors,
    		            borderWidth: 1
    		        }]
    		    },
    		    options: {
    		    	title: {
    		    		display: false,
    		    	},
    		    	legend: {
    		    		display: false,
    		    	},
    		    	maintainAspectRatio: false,
    		        scales: {
    		            yAxes: [{
    		                ticks: {
    		                    beginAtZero: true,
    		                    fontColor: '#555',
                                fontSize: 10 * $_WC.viewScale,
    		                }
    		            }],
    		            xAxes: [{
                            ticks: {
                                fontColor: '#555',
                                fontSize: 10 * $_WC.viewScale,
                            }
                        }]
    		        },
    		        layout: {
    		            padding: {
    		                top: 20 * $_WC.viewScale,
    		            }
    		        }
    		    }
    		};
    	},
    	hideChart: function() {
    	    this.showChart = false;
    	},
    	changeChart: function(btnType) {
    	    if(btnType == 'pre') {
    	        if(this.chartIdx <= 0) {
    	            this.chartIdx = 2;
    	        } else {
        	        this.chartIdx--;    	            
    	        }
    	    }
    	    if(btnType == 'next') {
    	        if(this.chartIdx >= 2) {
    	            this.chartIdx = 0;
    	        } else {
    	            this.chartIdx++;
    	        }
    	    }
    	},
    	setDate: function(livePpltnStts) {
    	    if(livePpltnStts.length > 0) {
        	    let date = new Date(livePpltnStts[0].PPLTN_TIME);
        	    let dateStr = date.getFullYear() + '년 ' + (date.getMonth() + 1) + '월 ' + date.getDate() + '일';
        	    return dateStr;    	            	        
    	    }
    	},
    	chargerRate: function(chargerSum) {
    	    if(typeof chargerSum !== 'undefined' && Object.keys(chargerSum).length > 0) {
    	        let result = (chargerSum.avCnt / chargerSum.totalCnt) * 100;
    	        result = result.toFixed(1);
    	        return result;
    	    }
    	},
    	setMfPerc: function(data, valNum1, valNum2) {
    	    let val = 0;
    	    if(!!data) {
    	        let compVal1 = Number(data[valNum1]);
    	        let compVal2 = Number(data[valNum2]);
    	        val = (compVal1 - compVal2).toFixed(1);
    	        if(val < 0) {
    	            val = val * (-1);
    	        }
    	    }
    	    return val;
    	},
    	setSentence: function(data, valNum1, valNum2) {
    	    let txt = '많아요';
    	    if(!!data) {
    	        let compVal1 = Number(data[valNum1]);
                let compVal2 = Number(data[valNum2]);
                let val = (compVal1 - compVal2).toFixed(1);
                if(val < 0) {
                    txt = '적어요';
                }
            }
    	    return txt;
    	},
    	setMostAge: function(data) {
    	    let map = {
    	            value: 0,
    	            valKd: '',
    	    }
    	    if(!!data) {
    	        let list = [Number(data.val8),Number(data.val9), Number(data.val10), Number(data.val11), Number(data.val12), Number(data.val13), Number(data.val14)
    	            , Number(data.val15)];
	            let val = 0;
	            let index = 0;
    	        list.forEach(function(d, idx) {
    	            if(d > val) {
    	                val = d;
    	                index = idx;
    	            }
    	        });
    	        map.value = val;
    	        switch (index) {
    	            case 0:map.valKd = '0~10세'
    	                break;
    	            case 1:map.valKd = '10대'
                        break;
    	            case 2:map.valKd = '20대'
                        break;
    	            case 3:map.valKd = '30대'
                        break;
    	            case 4:map.valKd = '40대'
                        break;
    	            case 5:map.valKd = '50대'
                        break;
    	            case 6:map.valKd = '60대'
                        break;
    	            case 7:map.valKd = '70대'
                        break;
                    default:map.valKd = ''
                        break;
                }
    	    }
	        return map;
    	},
    	setRoadImgIdx: function(roadTxt) {
    	    let roadIdx = '';
    	    if(!!roadTxt) {
    	        if(roadTxt == '원활') {
    	            roadIdx = '1';
    	        }
    	        if(roadTxt == '서행') {
                    roadIdx = '2';
                }
    	        if(roadTxt == '정체') {
                    roadIdx = '3';
                }
    	    }
    	    return roadIdx;
    	},
    	setRoadStsClr: function(idx) {
    	    let style = '';
    	    if(!!idx) {
    	        if(idx == '원활') {
    	            style += '#33DB87'
    	        }
    	        if(idx == '서행') {
                    style += '#FFC033'
                }
    	        if(idx == '정체') {
                    style += '#E34B63'
                }
    	    }
    	    return style;
    	},
    	setTotalPk: function(dataList) {
    	    if(!!dataList) {
    	        let map = {
	                available: 0,
	                cur: 0,
	                total: 0,
	                perc: 0,
    	        }
    	        dataList.forEach(function(d) {
    	            if(d.CUR_PRK_YN == 'Y') {
        	            let curPk = 0;
        	            let totalVal = 0;
        	            if(d.CUR_PRK_CNT == '') {
        	                curPk = 0;
        	            } else {
        	                curPk = Number(d.CUR_PRK_CNT);
        	            }
        	            if(d.CPCTY == '') {
        	                totalVal = 0;
                        } else {
                            totalVal = Number(d.CPCTY);
                        }
        	            map.cur += curPk;
        	            map.total += totalVal;    	                
    	            }
    	        });
    	        map.available = map.total - map.cur;
                if(map.total == 0) {
                    map.perc = 0;
                } else {
                    map.perc = ((map.available / map.total) * 100).toFixed(1); 
                }
                return map;
    	    }
    	},
    	setWeatherHour: function(wStr) {
    	    if(!!wStr) {
    	        let hourStr = '';
    	        hourStr = wStr.substring(8, 10) + '시';
    	        return hourStr;
    	    }
    	},
    	setWeatherIc: function(fcst, sunrise, sunset) {
    	    if(!!fcst) {
    	        let icon = '';
    	        let status = '';
    	        let hourTm = Number(fcst.FCST_DT.substring(8, 10));
    	        let riseTm = Number(sunrise.substring(0, 2)); 
    	        let setTm = Number(sunset.substring(0, 2));
    	        
    	        // 일출 일몰 시간과 비교
    	        if(hourTm > setTm || hourTm <= riseTm) {
    	            status = 'night';
    	        }
    	        
    	        // 흐림 cloudy
    	        // 구름많음 낮/밤   halfsun/ cloudy_night
    	        // 맑음
    	        // PRECPT_TYPE = 비 / 눈 || 없음 : 구름
    	        if(fcst.SKY_STTS == '맑음') {
    	            if(status == 'night') {
    	                icon = 'clear_night';
    	            } else {
    	                icon = 'sunny';
    	            }
    	            
    	            // 왜 맑음인데 비로 오는지 모르겠지만, 데이터가 그렇게 들어옴.
    	            if(fcst.PRECPT_TYPE == '비' || fcst.PRECPT_TYPE == '빗방울') {
                        icon = 'rain';
                    }
    	        }
    	        if(fcst.SKY_STTS == '구름많음') {
    	            if(status == 'night') {
                        icon = 'cloudy_night';
                    } else {
                        icon = 'halfsun';
                    }
    	        }
    	        if(fcst.SKY_STTS == '흐림') {
    	            if(fcst.PRECPT_TYPE == '없음') {
    	                icon = 'cloudy';
    	            }
    	            if(fcst.PRECPT_TYPE == '비' || fcst.PRECPT_TYPE == '빗방울') {
                        icon = 'rain';
                    }
    	            if(fcst.PRECPT_TYPE == '눈' || fcst.PRECPT_TYPE == '눈날림') {
                        icon = 'snow';
                    }
    	        }
    	        return icon;
    	    }
    	},
    	setWeatherIdx: function(idx) {
    	    let index = 1;
    	    if(idx == '좋음') {
    	        index = 1;
    	    }
    	    if(idx == '보통') {
    	        index = 2;
    	    }
    	    if(idx == '나쁨') {
    	        index = 3;
    	    }
    	    if(idx == '매우 나쁨') {
    	        index = 4;
    	    }
    	    return index;
    	},
    	
    	chargerState: function(list, type) {
    	    let map = {
    	            usable: 0,
    	            total: 0,
    	    }
    	    if(!!list) {
    	        list.forEach(function(cg) {
                    if(!!cg.CHARGER_DETAILS) {
                        cg.CHARGER_DETAILS.forEach(function(cd) {
                            if(cd.CHARGER_STAT == '사용가능') {
                                map.usable++;
                            }
                            map.total++;
                        })
                    }
    	        });
    	    }
    	    if(type == '사용가능') {
    	        return map.usable;
    	    }else {
    	        return map.total;
    	    }
    	},
    	
    	subwayUnduplication: function(subStts) {
            if(typeof subStts !== 'undefined' && subStts.length > 0) {
                let list = [];
                subStts.forEach(function(data) {
                    if(list.indexOf(data.SUB_STN_LINE) == -1) {
                        list.push(data.SUB_STN_LINE);                  
                    }
                });
                return list;
            }
        },
        
        selectSubMenu: function(submenu) {
            if(!!submenu) {
                let list = [];
                list.push(submenu);
                this.$store.dispatch("SET_SELECTED_SUB_MENUS", list);
            }
        },

        setCultureUrl: function(ev) {
            // let reg = /[`,，《》≪≫~!@#$%^&*()_|+\-=?;:'"<>\{\}\[\]\\\/ ]/gim;
            let reg = $_WC.eventReg;
            let eventNm = ev.EVENT_NM;
            if(reg.test(eventNm)) {
                eventNm = eventNm.replace(reg, '');
            }
            // console.log('eventNm', eventNm);
            if(Object.keys(this.cultureEvent).length > 0) {
                if(typeof this.cultureEvent[eventNm] !== 'undefined') {
                    return this.cultureEvent[eventNm][0].val12;
                }
            }
        },

        setSubwayImgNumber(sub) {
            if(!!sub) {
                let line = sub;
                if(sub == '공항철도') {
                    line = '97';
                }
                if(sub == '수인분당선') {
                    line = '98';
                }
                if(sub == '신분당선') {
                    line = '99';
                }
                return line;
            }
        },

        setRoadStatus(roadStatusNm) {
            let statusNumber = '';
            if(roadStatusNm == '원활') {
                statusNumber = '1';
            }
            if(roadStatusNm == '서행') {
                statusNumber = '2';
            }
            if(roadStatusNm == '정체') {
                statusNumber = '3';
            }
            return statusNumber;
        }
    },
    mixins: [naverMapShareMixins],
};
</script>